import { Button, Toast } from '@byecode/ui'
import type { OtherPlatformType } from '@lighthouse/shared'
import { TitleInContentModal, useAtomAction } from '@lighthouse/shared'
import * as React from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'

import { fetchOtherPlatformsAtom } from '@/atoms/application/action'
import * as srv from '@/services'

import { INTEGRATION_LIST, otherPlatformNameMap } from './constant'
import { OtherPlatformsItem } from './Item'

interface OtherPlatformInstallModalProps {
    type?: OtherPlatformType
    onClose?: () => void
}
const SCxSubTitle = styled.div`
    font-size: 14px;
    color: var(--color-gray-500);
    line-height: 22px;
    margin: 20px 0;
`
const SCxFooter = styled.div`
    height: 72px;
    padding: 0 20px;
    background-color: var(--color-gray-50);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;

    button {
        height: 40px;
        width: 104px;
    }
`

const SCxContainer = styled.div`
    padding: 0 32px 32px 32px;
`

const OtherPlatformInstallModal: React.FunctionComponent<OtherPlatformInstallModalProps> = ({ type, onClose }) => {
    const item = INTEGRATION_LIST.flatMap(v => v.list).find(v => v.type === type)
    const { run: fetchOtherPlatforms } = useAtomAction(fetchOtherPlatformsAtom)

    const handleInstallIntegration = useCallback(async () => {
        if (!type) {
            return
        }
        const res = await srv.addIntegration(type)
        if (res) {
            fetchOtherPlatforms()
            Toast.success(`${otherPlatformNameMap[type]}安装成功`)
            onClose?.()
        }
    }, [type, fetchOtherPlatforms, onClose])

    return (
        <TitleInContentModal width={564} title="插件安装提示" open={!!type} onClose={onClose}>
            <SCxContainer>
                <SCxSubTitle>使用该功能前，需要先安装以下插件：</SCxSubTitle>
                {item && (
                    <OtherPlatformsItem
                        width="100%"
                        lookType="alreadyInstall"
                        data={item}
                        readonly
                        style={
                            {
                                // height: 'auto'
                            }
                        }
                    />
                )}
            </SCxContainer>
            <SCxFooter>
                <Button onClick={onClose}>取消</Button>
                <Button type="primary" onClick={handleInstallIntegration}>
                    确认安装
                </Button>
            </SCxFooter>
        </TitleInContentModal>
    )
}

export default OtherPlatformInstallModal
